// eslint-disable-next-line import/prefer-default-export
export const openWebWidget = () => {
  // @ts-ignore : As We are using frontapp variable which is set dynamically from external script
  FrontChat("show");
};

type Environment = "dev" | "stage" | "prod";

const PROJECT_ENVIRONMENTS: Record<string, Environment> = {
  "deep-thought-swyft-staging": "stage",
  "deepthought-swyft-dev": "dev",
  "deep-thought-swyft": "prod",
};

export const getEnvironment = (): Environment =>
  PROJECT_ENVIRONMENTS[process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID ?? ""] ??
  "dev";

export const getReturnmatesTrackingPageDomain = (trackingNumber: string) => {
  const env = getEnvironment();
  const returnmatesMode = env === "prod" ? "" : `${env}.`;

  return `https://${returnmatesMode}returnmates.com/tracking/${trackingNumber}`;
};

const NEW_TRACKING_PAGE_HOSTS: Record<Environment, string> = {
  prod: "https://track.shipsway.com",
  stage: "https://track-stage.shipsway.com",
  dev: "https://track-dev.shipsway.com",
};

/**
 * URL of the same shipment on the new customer tracking page (sway-tracking).
 * Without a tracking number it points at the page's search form.
 */
export const getNewTrackingPageUrl = (trackingNumber?: string) => {
  const host = NEW_TRACKING_PAGE_HOSTS[getEnvironment()];

  return trackingNumber
    ? `${host}/track/${encodeURIComponent(trackingNumber)}`
    : `${host}/track`;
};
